<template>
  <div id="app">
    <header :class="{header: currentStep > 0}">
      <div class="container container-header">
        <div class="header-box">
          <div class="container-inner">
            <h1 class="heading-primary">
              See If You Qualify For HARP
            </h1>
            <!--<h4 class="sub-heading">Over 3 million people have refinanced their home with HARP.</h4>-->
          </div>
        </div>
      </div>
      <div class="filter--blue" />
    </header>
    <main class="container">
      <div
        v-if="currentStep === 0"
        class="main-box"
      >
        <div class="container-inner">
          <h2 class="heading-secondary">Take This Quiz to Calculate Your Savings!</h2>
        </div>
        <div class="main-box-bottom">
          <div class="main-box-bottom-triangle" />
        </div>
      </div>
      <ProgressBar
        v-if="currentStep > 0 && currentStep < 12"
        :current-step="currentStep"
        :max-steps="stepsList.length"
      />
      <Form
        v-if="currentStep < 12"
        :step="stepsList[currentStep]"
        @stepValid="changeStep"
        @skipToNext="skipStep"
      />
      <Loader v-if="currentStep === 12" />
    </main>
  </div>
</template>

<script>
import ProgressBar from './components/common/ProgressBar'
import Form from './components/Form'
import Loader from './components/form-elements/Loader'

import axios from 'axios'
import qs from 'qs'

export default {
  components: {
    ProgressBar,
    Form,
    Loader
  },
  data () {
    return {
      currentStep: 0,
      campId: '',
      clickId: '',
      formData: {},
      stepsList: ['property-zip', 'property-type', 'property-use', 'property-value', 'mortgage-balance', 'cashout', 'credit-rating', 'is-veteran', 'home-address', 'personal-info', 'ssn', 'personal-contacts'],
      stepsHistory: []
    }
  },
  watch: {
    '$route' (newValue, oldValue) {
      let toStep = newValue.path.replace(process.env.VUE_APP_SUBDIR + '/', '')
      let fromStep = oldValue.path.replace(process.env.VUE_APP_SUBDIR + '/', '')

      let forward = this.isForward(toStep, fromStep)
      if (forward === false && fromStep !== '') {
        if (this.isVisited(toStep) === true) {
          let previousStepName = this.stepsHistory[this.stepsHistory.indexOf(fromStep) - 1]
          this.currentStep = this.stepsList.indexOf(previousStepName)
        }
      }
      if (this.currentStep < 0) {
        this.currentStep = 0
      }
      if (process.env.NODE_ENV === 'production') {
        this.$gtm.push({
          event: 'VirtualPageview',
          virtualPageURL: this.stepsList[this.currentStep],
          virtualPageTitle: this.stepsList[this.currentStep]
        })
      }
    }
  },
  created () {
    const queryParams = this.$route.query
    this.clickId = queryParams['clickid']
    this.campId = queryParams['campid']
    this.$router.push({ path: this.stepsList[0], name: this.stepsList[0], query: this.$route.query })
    this.stepsHistory.push(this.stepsList[0])
  },
  mounted: function () {
    window.onbeforeunload = this.leaving
  },
  methods: {
    changeStep (data) {
      let direction = 'next'
      this.formData = data
      // localStorage.formInfo = JSON.stringify(data)
      // localStorage.visitedSites = JSON.stringify(this.stepsHistory)
      if (direction === 'next') {
        if (this.stepsList.length - 1 === this.currentStep) {
          if (this.formData.leadID === '') {
            this.formData.leadID = 'NOTFOUND'
          }
          data.ssn = this.checkData(data.ssn, '')
          data.campId = this.campId
          data.clickId = this.clickId
          data.a = 'sendLead'
          this.currentStep++
          axios.get('//' + process.env.VUE_APP_LINK + '/formApi.php?' + qs.stringify(data, { encode: true })).then((response) => {
            window.location.href = 'thank-you.html'
          }).catch((e) => {
            console.log(e)
          })
        } else {
          this.currentStep++
          this.$router.push({ path: this.stepsList[this.currentStep], name: this.stepsList[this.currentStep], query: this.$route.query })
        }
        this.insertValue(this.currentStep, this.stepsList[this.currentStep])
      } else {
        this.currentStep--
      }
    },
    skipStep (data) {
      this.formData = data
      this.stepsHistory.splice(this.currentStep + 1, 1)
      this.currentStep += 2
      this.$router.push({ path: this.stepsList[this.currentStep], name: this.stepsList[this.currentStep], query: this.$route.query })
      this.insertValue(this.currentStep, this.stepsList[this.currentStep])
      // localStorage.formInfo = JSON.stringify(data)
    },
    isForward (to, from) {
      return (this.stepsList.indexOf(to) >= this.stepsList.indexOf(from))
    },
    isVisited (to) {
      return (this.stepsHistory.indexOf(to) > -1)
    },
    insertValue (index, value) {
      if (!this.stepsHistory.includes(this.stepsList[this.currentStep])) this.stepsHistory.splice(index, 0, value)
    },
    checkData (index, value = '') {
      return (!index) ? value : index
    },
    leaving (e) {
      if (this.currentStep < 12) {
        e.returnValue = false
      }
    }
  }
}
</script>
